import React from 'react'
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import UserInformation from "./pages/userInformation";
import HomeStructure from "./pages/HomeStructure ";
import './App.css'
import Index from "./pages";
import QuizResult from "./pages/QuizResult";
import LoaderScr from './components/LoaderScr';
import Login from './pages/Login';
import { Healthindex } from './pages/Healthindex';
import { Legalindex } from './pages/Legalindex';
import UserInformation2 from './pages/userInformation2';
import UserInformation3 from './pages/useInformation3';
import ScrollToTop from "./ScrollToTop";
import Layout from "./Layout.jsx"


function App() {  

  const router = createBrowserRouter([
    {
      path: "user-information/home-fitness-quiz",
      loader: () => {
        window.location.replace("https://agingoptions.com/home-quiz/");
        return null;
      },
    },

     {
      path: "user-information/health-fitness-quiz",
      loader: () => {
        window.location.replace("https://agingoptions.com/health-quiz/");
        return null;
      },
    }
    ,
    {
      path: "user-information/legal-readiness-quiz",
      element: (<Layout><UserInformation3 /></Layout>),
      errorElement: (<div>Dang!</div>),
    }
    ,
    {
      path: "user-information/home-fitness-quiz/home",
      loader: () => {
        window.location.replace("https://agingoptions.com/home-quiz/");
        return null;
      },
    }
    ,
    {
      path: "user-information/health-fitness-quiz/health",
      loader: () => {
        window.location.replace("https://agingoptions.com/health-quiz/");
        return null;
      },
    },
    {
      path: "user-information/legal-readiness-quiz/legal",
      element: (<Layout><Legalindex /></Layout>),
      errorElement: (<div>Dang!</div>),
    },
    {
      path: "user-information/fitness-quiz-result",
      element: (<Layout><QuizResult /></Layout>),
      errorElement: (<div>Dang!</div>),
    },{
      path: "/",
      element: (<Layout><Login /></Layout>),
      errorElement: (<div>Dang!</div>),
    }
    
  ],{
    basename: '/'
  })

  return (<RouterProvider router={router} fallbackElement={<div>Dang!</div>}/>);
}

export default App;
